/**
 * Action types for company reducer
 */
export default {
    FETCH_INIT: "TAGS/FETCH_INIT",
    FETCH_SUCCESS: "TAGS/FETCH_SUCCESS"
};
